export default __webpack_public_path__ + "static/media/Wonde_Logo.8a681cb2.png";